import { Injectable, signal, WritableSignal } from '@angular/core';
import { Subject } from "rxjs";
import { BootstrapScreenDimensionId, ViewportSize } from "../html/size-detector/size-detector.component";

@Injectable({
  providedIn: 'root'
})
export class ScreenSizeService {
  private currentDimension: BootstrapScreenDimensionId = 'xs'
  private dimensionMap: Map<BootstrapScreenDimensionId, number> = new Map<BootstrapScreenDimensionId, number>([
    ['xs', 0],
    ['sm', 1],
    ['md', 2],
    ['lg', 3],
    ['xl', 4],
    ['xxl', 5],
  ])

  private dimensionChangeSubject: Subject<BootstrapScreenDimensionId>
  private viewportSizeChangeSubject: Subject<ViewportSize>

  private dimensionSignal: WritableSignal<BootstrapScreenDimensionId> = signal("xs")
  private viewportSizeSignal: WritableSignal<ViewportSize | undefined> = signal(undefined)

  constructor() {
    this.dimensionChangeSubject = new Subject<BootstrapScreenDimensionId>()
    this.dimensionChangeSubject.subscribe(id => {
      this.currentDimension = id
      this.dimensionSignal.set(id)
    })

    this.viewportSizeChangeSubject = new Subject<ViewportSize>()
    this.viewportSizeChangeSubject.subscribe(vs => {
      this.viewportSizeSignal.set(vs)
    })
  }

  getDimensionSignal() {
    return this.dimensionSignal.asReadonly()
  }

  getViewportSizeSignal() {
    return this.viewportSizeSignal.asReadonly()
  }

  /**
   * @deprecated
   *
   * Use getDimensionSignal() instead
   */
  getDimensionChangeSubject(): Subject<BootstrapScreenDimensionId> {
    return this.dimensionChangeSubject
  }

  /**
   * @deprecated
   *
   * Use getViewportSizeSignal() instead
   */
  getViewportSizeChangeSubject(): Subject<ViewportSize> {
    return this.viewportSizeChangeSubject
  }
  getCurrentDimension(): BootstrapScreenDimensionId {
    return this.currentDimension
  }
  currentDimensionIsLargerThan(dimension: BootstrapScreenDimensionId) {
    return this.dimensionMap.get(this.currentDimension)! > this.dimensionMap.get(dimension)!
  }
  currentDimensionIsLargerThanEqual(dimension: BootstrapScreenDimensionId) {
    return this.dimensionMap.get(this.currentDimension)! >= this.dimensionMap.get(dimension)!
  }
  currentDimensionIsSmallerThan(dimension: BootstrapScreenDimensionId) {
    return this.dimensionMap.get(this.currentDimension)! < this.dimensionMap.get(dimension)!
  }
  currentDimensionIsSmallerThanEqual(dimension: BootstrapScreenDimensionId) {
    return this.dimensionMap.get(this.currentDimension)! <= this.dimensionMap.get(dimension)!
  }

  dimensionIsLargerThan(dimension: BootstrapScreenDimensionId, compareToDimension: BootstrapScreenDimensionId) {
    return this.dimensionMap.get(dimension)! > this.dimensionMap.get(compareToDimension)!
  }
  dimensionIsLargerThanEqual(dimension: BootstrapScreenDimensionId, compareToDimension: BootstrapScreenDimensionId) {
    return this.dimensionMap.get(dimension)! >= this.dimensionMap.get(compareToDimension)!
  }
  dimensionIsSmallerThan(dimension: BootstrapScreenDimensionId, compareToDimension: BootstrapScreenDimensionId) {
    return this.dimensionMap.get(dimension)! < this.dimensionMap.get(compareToDimension)!
  }
  dimensionIsSmallerThanEqual(dimension: BootstrapScreenDimensionId, compareToDimension: BootstrapScreenDimensionId) {
    return this.dimensionMap.get(dimension)! <= this.dimensionMap.get(compareToDimension)!
  }
  dimensionIsEqual(dimension: BootstrapScreenDimensionId, compareToDimension: BootstrapScreenDimensionId) {
    return this.dimensionMap.get(compareToDimension)! == this.dimensionMap.get(dimension)!
  }

  getScreenHeight(): number {
    if (typeof window === 'undefined') return 0
    return window.innerHeight
  }
  getScreenWidth(): number {
    if (typeof window === 'undefined') return 0
    return window.innerWidth
  }
}
